import GameCard from "./GameCard";

class StationGameCard extends GameCard{
    constructor(isLucky, type, id, value) {
        super(isLucky);
        this.type = type;
        this.id = id;
        this.value = value;
    }
}
export default StationGameCard;